import { render, staticRenderFns } from "./PostEditModal.vue?vue&type=template&id=5dc8c4be&"
import script from "./PostEditModal.vue?vue&type=script&lang=js&"
export * from "./PostEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports